// extracted by mini-css-extract-plugin
export default {"section":"SectionHome_section__nmmjA","container":"SectionHome_container__NtEjr","title":"SectionHome_title__-mfG4","img":"SectionHome_img__D8Ml7"};